"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var MenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(MenuItem, _super);
    function MenuItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onClick = function (e) {
            var onClick = _this.props.onClick;
            var onMenuItemClick = _this.context.onMenuItemClick;
            onMenuItemClick && onMenuItemClick(e);
            onClick && onClick(e);
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, iconName = _b.iconName, iconSize = _b.iconSize, label = _b.label, active = _b.active, link = _b.link, others = tslib_1.__rest(_b, ["theme", "className", "iconName", "iconSize", "label", "active", "link"]);
        var classes = classnames_1.default(theme.item, className, (_a = {},
            _a[theme.link] = link && this.context.linkComponent,
            _a[theme.active] = active,
            _a));
        var content = (React.createElement(React.Fragment, null,
            iconName ? React.createElement("div", { className: theme.icon },
                React.createElement(icon_1.default, { iconName: iconName, size: iconSize })) : null,
            React.createElement("div", { className: theme.label }, label)));
        if (link && this.context.linkComponent) {
            var LinkComponent = this.context.linkComponent;
            content = React.createElement(LinkComponent, tslib_1.__assign({}, link), content);
        }
        return (React.createElement("li", tslib_1.__assign({}, others, { className: classes, onClick: this.onClick }), content));
    };
    MenuItem.defaultProps = {
        iconSize: 2,
        active: false
    };
    MenuItem.contextTypes = {
        onMenuItemClick: PropTypes.func,
        linkComponent: PropTypes.any
    };
    return MenuItem;
}(React.Component));
exports.default = MenuItem;
